import { RadioGroup, RadioGroupItem } from "../ui/radio-group";
import { sanitizeDisplayText } from "../../utils/priceUtils";

/**
 * Radio Question component
 */
export const RadioQuestion = ({ 
  question,
  value,
  onChange,
  className = ""
}) => {
  return (
    <div className={className}>
      <RadioGroup
        value={value || ""}
        onValueChange={onChange}
        className="space-y-3"
      >
        {question.options.map((option) => (
          <label
            key={option.value}
            className={`flex items-center gap-4 p-4 bg-gray-50 border rounded-xl cursor-pointer transition-all hover:border-[#0FA3B1]/50 ${
              value === option.value
                ? "border-[#0FA3B1] bg-[#0FA3B1]/5"
                : "border-gray-200"
            }`}
            data-testid={`option-${option.value}`}
          >
            <RadioGroupItem
              value={option.value}
              className="border-2 border-gray-300 text-[#0FA3B1]"
            />
            <span className="text-[#1F2933] flex-1">
              {sanitizeDisplayText(option.label)}
            </span>
          </label>
        ))}
      </RadioGroup>
    </div>
  );
};

export default RadioQuestion;
